import resourceConfig from '../config';

export default {
  resources: {
    [resourceConfig.name]: {
      openAction: 'LOAD KM FROM DOC',
      title: 'LOAD KM FROM DOC',
      executeAction: 'Submit',
      errorMessage: 'Error',
      successMessage: 'Success',
      fields: {
        'cisPackageTypeUNIT': 'Cis package type',
        'documentId': 'Document id',
        'packs': 'Packs',
        'statusExt': 'Status ext',
        'tree': 'Tree',
        'status': 'Status',
        'number': 'Document number',
        'limit': 'Number of KM in document',
        'pageNumber': 'Page number',
      }
    }
  }
} 